export interface ButtonProps {
  id?: string;
  className?: string;
  variant: ButtonVariant;
  size: ButtonSize;
  onClick: () => null | void;
  children?: React.ReactNode;
  to?: string;
  noUnderline?: boolean;
}

export enum ButtonVariant {
  PRIMARY = "primary",
  ACCENT = "accent",
}

export enum ButtonSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
  FULL_WIDTH = "full-width",
}